import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiceDetailPage.css';

const AuxiliaresPage = () => {
  const subServices = [
    {
      title: 'Recepción y Atención al Cliente',
      description: 'Personal profesional para brindar una excelente primera impresión y atención de calidad.',
      features: [
        'Recepcionistas bilingües',
        'Atención telefónica y presencial',
        'Gestión de correspondencia',
        'Control de accesos',
        'Información y orientación'
      ]
    },
    {
      title: 'Seguridad y Vigilancia',
      description: 'Servicios de seguridad integral para proteger personas, instalaciones y activos.',
      features: [
        'Vigilancia presencial 24/7',
        'Control de accesos vehicular y peatonal',
        'Rondas de seguridad',
        'Personal certificado y capacitado',
        'Sistemas de monitoreo'
      ]
    },
    {
      title: 'Logística y Almacén',
      description: 'Gestión eficiente de operaciones logísticas y manejo de almacenes.',
      features: [
        'Recepción y despacho de mercancías',
        'Control de inventarios',
        'Picking y packing',
        'Carga y descarga',
        'Gestión de documentación'
      ]
    },
    {
      title: 'Servicios Generales',
      description: 'Personal de apoyo para operaciones diarias y servicios complementarios.',
      features: [
        'Mensajería y courrier',
        'Manejo de archivos',
        'Apoyo administrativo',
        'Servicios de cafetería',
        'Gestión de facilities'
      ]
    },
    {
      title: 'Jardinería y Áreas Verdes',
      description: 'Mantenimiento profesional de jardines, parques y espacios verdes.',
      features: [
        'Diseño y paisajismo',
        'Mantenimiento de jardines',
        'Poda y corte de césped',
        'Riego y fertilización',
        'Control de plagas ecológico'
      ]
    },
    {
      title: 'Conductor y Chofer',
      description: 'Servicios de conducción profesional para ejecutivos y transporte corporativo.',
      features: [
        'Choferes profesionales',
        'Conocimiento de rutas',
        'Vehículos corporativos',
        'Servicio de protocolo',
        'Disponibilidad flexible'
      ]
    }
  ];

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Servicios Auxiliares</h1>
          <p>Personal especializado para el éxito operacional de su empresa</p>
        </div>
      </section>

      <section className="service-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Apoyo Integral para su Operación</h2>
              <p>
                Nuestros servicios auxiliares están diseñados para optimizar las operaciones de su empresa,
                permitiéndole enfocarse en su core business mientras nosotros nos encargamos de los servicios
                de apoyo esenciales.
              </p>
              <p>
                Contamos con personal altamente capacitado y comprometido, seleccionado bajo rigurosos
                estándares de calidad para garantizar el mejor servicio en cada área.
              </p>
            </div>
            <div className="intro-image">
              <img
                src="/images/auxiliares-principal.jpeg"
                alt="Servicios Auxiliares"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 400"%3E%3Crect fill="%230D3B66" width="500" height="400"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="80"%3E👥%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sub-services">
        <div className="container">
          <h2>Nuestros Servicios Auxiliares</h2>
          <div className="sub-services-grid">
            {subServices.map((service, index) => (
              <div key={index} className="sub-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-benefits">
        <div className="container">
          <h2>Ventajas de Nuestros Servicios Auxiliares</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h3>Personal Calificado</h3>
              <p>Selección rigurosa y capacitación continua</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">💼</div>
              <h3>Gestión Integral</h3>
              <p>Administración completa del personal asignado</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📊</div>
              <h3>Control de Calidad</h3>
              <p>Supervisión constante y reportes periódicos</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚖️</div>
              <h3>Cumplimiento Legal</h3>
              <p>Todas las obligaciones laborales cubiertas</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>¿Necesita personal de apoyo?</h2>
          <p>Contáctenos y diseñaremos la solución perfecta para su empresa</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn-primary">Solicitar Cotización</Link>
            <Link to="/servicios" className="btn-secondary">Ver Todos los Servicios</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuxiliaresPage;
